"use client";

import { type AuthResult, auth } from "@repo/api/client";
import React, { useEffect } from "react";

const AuthContext = React.createContext(null);

export type AuthProviderProps = Readonly<{
  onUpdateUser: (user: AuthResult["user"] | null) => void;
  onError?: (error: Error) => void;
  children: React.ReactNode;
}>;

export function AuthProvider({ children, onUpdateUser, onError }: AuthProviderProps): React.ReactElement {
  // set subscription to auth state
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(
      (user) => {
        if (user === null) {
          // user is logged out
          onUpdateUser(null);
        } else {
          onUpdateUser(user);
        }
      },
      (error) => {
        console.error(error);
        onError?.(new Error("An error occurred while trying to get auth data"));
      },
    );

    return unsubscribe;
  }, [onUpdateUser]);

  return <AuthContext.Provider value={null}>{children}</AuthContext.Provider>;
}
